import { createModalStore } from '@/shared/lib/modal';

export const useAddEmailModalStore = createModalStore();
